import { CircularProgress } from '@material-ui/core';
import React from 'react';

export const ChatContentLoader = () => {
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    const delayTimer = setTimeout(() => {
      setShowLoader(true);
    }, 500);

    return () => {
      clearTimeout(delayTimer);
    };
  }, []);

  return showLoader ? <CircularProgress className="absolute top-1/2" /> : null;
};
